module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA5UExURUdwTP///////////////////////////////////////////////////////////////////////308lk0AAAASdFJOUwD43CvBYI+wQPAUSwR2taeEnN99TlcAAABzSURBVBjTzc/dDoAgCAZQFPrD1OL9HzZx1WK0ddt3gzs6QGCSmMCFRCSwY9H451EZHacgMvrewAnhMyuvvW5EVACwFUIsrWXM7WZqExeAWSfn0PeSyfKpuvCT71TLmXnTGg2X63/BjlSuejI8KO/vPP6LD6UTEAOPG4G6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/LinkedIn_0609.png
// module id = 1568
// module chunks = 5